import type { MagicLinkFlow } from "./types";

export default function buildZippyDeepLink(
  flow: MagicLinkFlow,
  token: string,
): string {
  const encoded = encodeURIComponent(token);
  return `zippy://${flow}/email?token=${encoded}`;
}
